import {
	AttachmentsBlock,
	AttachmentsBlocksList,
	GenericAttachedFile
} from '@shared/components/view-files/models/attachments-interface';

export abstract class AttachmentsAdapter<T> implements AttachmentsBlocksList {
	attachmentsBlocks: AttachmentsBlock[] = [];

	/**
	 * Call this method in extended class to generate blocks
	 * @param title
	 * @param canAdd
	 * @param canEdit
	 * @param attachments
	 */
	protected createAttachmentsBlock(title: string, canAdd: boolean, canEdit: boolean, attachments: T[]): void {
		this.attachmentsBlocks.push({
			title: title,
			canAdd: canAdd,
			canEdit: canEdit,
			items: attachments ? this.adaptAttachment(attachments) : []
		});
	}

	private adaptAttachment(attachments: T[]): GenericAttachedFile[] {
		return attachments.map<GenericAttachedFile>(attachment => this.createAttachedFile(attachment));
	}

	/**
	 * Have to implement this method to map component specific attachment object to generic object
	 * @param moduleSpecificAttachment
	 */
	abstract createAttachedFile(moduleSpecificAttachment: T): GenericAttachedFile;
}
